import React from "react";

import DataGrid from "../../../../components/dataGrid/dataGrid";
import {
    DashboardPointInstancesResponse
} from "../../../../services/partnerCenterService";
import { SuspenseComponentProps } from "../../containers/suspenseContainer";


import TenantListConfig from "./tenantList.config";
import { mapDashboardPointInstancesResponse } from "./tenantList.model";

type TenantListProps = SuspenseComponentProps<DashboardPointInstancesResponse>

const TenantList: React.FC<TenantListProps> = ({ data }) => {
    if (data === undefined) {
        return null;
    }

    const dataSource = mapDashboardPointInstancesResponse(data.pointInstances);

    return (
        <DataGrid className="tenant-list" data-testid="tenant-list" dataSource={dataSource} columns={TenantListConfig.columnDefinitions} />
    );
}

export default TenantList;